import { CheckCircle2, X } from "lucide-react";
import { fmtMilli } from "../../lib/mshopCalc";

export default function SavedBanner({ op, onClose }) {
    return (
        <div className="mb-4 flex items-start gap-3 rounded-2xl bg-emerald-50 px-4 py-3 text-emerald-900 ring-1 ring-emerald-200" data-testid="mshop-saved-banner">
            <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0" />
            <div className="flex-1 text-sm">
                <div className="font-bold">تم الحفظ — {op.oman_date} • {op.oman_time.slice(0, 5)}</div>
                <div className="mt-0.5">
                    {op.inputs?.weight != null && <>الوزن <span className="font-numbers font-bold" dir="ltr">{fmtMilli(op.inputs.weight)}</span> جم • </>}
                    الكاش <span className="font-numbers font-bold" dir="ltr">{fmtMilli(op.inputs?.cash ?? op.cash_delta)}</span> ر.ع •
                    البنك <span className="font-numbers font-bold" dir="ltr">{fmtMilli(op.inputs?.bank ?? "0")}</span> ر.ع
                </div>
            </div>
            <button onClick={onClose} className="rounded p-1 hover:bg-emerald-100" data-testid="mshop-saved-banner-close"><X className="h-4 w-4" /></button>
        </div>
    );
}
